import React from 'react'


class Manual extends React.Component {

  


  render() {

    return(

      <div>
        

        <div className="container">

          <h1 style={{textAlign: 'center', margin: '60px 0 20px 0', color: '#816992'}}>{this.props.data.name}</h1>

          <div style={{display: 'flex', justifyContent: 'center'}}>

            <div style={{margin: '0 20px 0 20px'}}><a href={this.props.data.filePath} target="_blank"><img alt="" className="manual-image" src={this.props.data.file}/></a></div>

            { this.props.data.filePath2
            
            ?

            <div><a href={this.props.data.filePath2} target="_blank"><img alt="" className="manual-image" src={this.props.data.file2}/></a></div>

            :

            <p></p>
            
            }
          </div>

        </div>

      </div>
    )
  }
}

export default Manual



// WEBPACK FOOTER //
// ./src/components/ManualView.js